






































import { Component, Prop } from 'vue-property-decorator';
import { UseService } from '@/services/service';
import { BulletinCommentEntity } from '@/entities/bulletin-comment.entity';
import BulletinCommentService from '@/services/bulletin-comment.service';
import CEmoticonInput from '@/components/Helper/Form/CEmoticonInput.vue';
import CFileInput from '@/components/Helper/Button/CFileInput.vue';
import CommentBoxMixin from '@/mixin/comment-box.mixin';

@Component<CommentBulletin>({
  components: { CFileInput, CEmoticonInput },
})
export default class CommentBulletin extends CommentBoxMixin {
  @Prop({ type: Number })
  bulletinId: number;

  @Prop({ type: HTMLDivElement })
  container: HTMLDivElement;

  @Prop({ type: HTMLDivElement })
  content: HTMLDivElement;

  @UseService(BulletinCommentService)
  service: BulletinCommentService;

  commentData: Partial<BulletinCommentEntity> = {
    content: '',
    bulletinId: null,
  };

  created() {
    this.commentData.bulletinId = this.bulletinId;
  }
}
